import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MainService } from "src/app/services/main/main.service";
import { ContractDialogComponent } from "../../contract/contract-modal/contract-modal.component";

@Component({
  selector: "app-addcard",
  templateUrl: "./add-card.component.html",
  styleUrls: ["./add-card.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AddcardComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    private mainService: MainService
  ) { }

  ngOnInit() {
    this.getInstanCard();
  }
  cards: any = [];

  getInstanCard() {
    let token = localStorage.getItem('token');

    this.mainService
      .uploadApi({ access_token: token }, 'instant_card_listing', true)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.cards = data.result;
        }
      });
  }

  
  getCardBrandImage(card): string {
    if (card) { 
      let brand = (card.brand || card.card.brand).toLowerCase();
      let allowedBrands = ['mastercard', 'discover', 'jcb', 'visa', 'american express', "unionpay", 'diners', 'amex'];
      if (brand === 'american express' || brand == 'amex') {
        return `assets/img/svg/card-type/American Express.svg`;
      }
      if (brand === 'mastercard') {
        return `assets/img/svg/card-type/MasterCard.svg`;
      }
      if (brand === 'unionpay') {
        return `assets/img/svg/card-type/UnionPay.svg`;
      }
      if (brand === 'diners') {
        return `assets/img/svg/card-type/Diners Club.svg`;
      }
      if (brand === 'jcb') {
        return `assets/img/svg/card-type/JCB.svg`;
      }
      return brand && allowedBrands.includes(brand)
        ? `assets/img/svg/card-type/${this.capitalizeFirstLetter(brand)}.svg`
        : 'assets/img/svg/card-type/no_card.svg';
    }
  }
  capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  
  fileChangeEvent(event: any) {
    event.preventDefault();
    let tillaDialogRef = this.dialog.open(ContractDialogComponent, {
      width: "500px",
      disableClose: true,
      panelClass: "rightFullDialog",
      data: {
        type: 37,
        title: this.cards.length == 0 ? "Add Card" : "Update Card",
        action: this.cards.length == 0 ? "Add " : "Update",
        success: false,
        send_data: {
          type: "Customer",
        },
      },
    });
    tillaDialogRef.afterClosed().subscribe((result) => {
      this.getInstanCard();

      if (result !== 2 && result !== '2') {
      } else {
        return false;
      }
    });
  }

  cardInfo = {
    name: "",
    number: "",
    cvv: "",
    exp: "",
  };

  getCardInfo(e) {
    this.cardInfo[e.target.name] = e.target.value;
  }
}
